import React, { useEffect, useState } from "react";
import { ChevronRight, Loader2, MessageSquareHeart } from "lucide-react";
import api from "../../lib/api";

/**
 * On a participant's group card, while the final feedback questionnaire is
 * open and not yet sent (30.10.2026): a line straight to it, with a link of
 * its own, like the initial assessment's.
 */
export default function FeedbackLine({ groupId }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/portal/final-feedback")
      .then((r) => { if (alive) setOpen((r.data.items || []).some((i) => i.group_id === groupId && i.state === "open")); })
      .catch(() => {});
    return () => { alive = false; };
  }, [groupId]);

  if (!open) return null;

  const go = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/portal/final-feedback/${groupId}/link`);
      window.location.assign(r.data.url);
    } catch {
      setBusy(false);
      setOpen(false);
    }
  };

  return (
    <button type="button" onClick={go} disabled={busy} data-testid="portal-feedback-line"
      className="mt-4 flex w-full items-center gap-3 rounded-xl border border-[#965EA7]/25 bg-[#965EA7]/[0.04] px-4 py-3 text-left hover:border-[#965EA7]">
      {busy ? <Loader2 size={18} className="shrink-0 animate-spin text-[#965EA7]" /> : <MessageSquareHeart size={18} className="shrink-0 text-[#965EA7]" />}
      <span className="min-w-0 flex-1 text-sm">
        <span className="font-semibold text-[#373A45]">Spune-ne cum a fost cursul: aproximativ 3 minute</span>
        <span className="text-[#7A4986]"> · Completează chestionarul de feedback</span>
      </span>
      <ChevronRight size={16} className="shrink-0 text-[#9CA3AF]" />
    </button>
  );
}
